module.exports = __webpack_public_path__ + "media/src/images/partners/whu-744200b19386003ab9929bb582ce3cb9.jpg";